/**
 * Хук для валидации изображений
 * Проверяет формат и размер файла
 */

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/heic",
];
const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

/**
 * Проверяет формат изображения
 */
const validateImageFormat = (file) => {
  if (!file || !file.type) {
    return { isValid: false, error: "Неподдерживаемый формат изображения" };
  }

  const normalizedType = file.type.toLowerCase();
  const isValid = ALLOWED_TYPES.some((type) => normalizedType.includes(type));

  if (!isValid) {
    return { isValid: false, error: "Неподдерживаемый формат изображения" };
  }

  return { isValid: true, error: null };
};

/**
 * Проверяет размер файла
 */
const validateImageSize = (file) => {
  if (!file || !file.size) {
    return { isValid: false, error: "Слишком большой файл (макс. 10MB)" };
  }

  if (file.size > MAX_FILE_SIZE) {
    return { isValid: false, error: "Слишком большой файл (макс. 10MB)" };
  }

  return { isValid: true, error: null };
};

/**
 * Полная валидация изображения
 * @param {File} file - файл изображения
 * @returns {Promise<{isValid: boolean, error: string | null}>}
 */
export const useImageValidation = async (file) => {
  if (!file) {
    return { isValid: false, error: "Файл не выбран" };
  }

  // Проверка формата
  const formatCheck = validateImageFormat(file);
  if (!formatCheck.isValid) {
    return formatCheck;
  }

  // Проверка размера
  const sizeCheck = validateImageSize(file);
  if (!sizeCheck.isValid) {
    return sizeCheck;
  }

  return { isValid: true, error: null };
};

export default useImageValidation;
